// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreatePostmarkSetting_createButton__2p16O"};